import { mapGetters, mapState } from 'vuex';

var formMixin = {
  props: {
    claimId: {
      type: Number,
      default: null
    },
    form: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['countries', 'currencies']),
    ...mapState({
      documents: (state) => state.documents.documents
    })
  },
  methods: {
    commit(propertyName, value) {
      this.$store.commit('SET_QUESTION_VALUE', {
        type: this.form.type,
        question: propertyName,
        value
      });

      if (value) {
        this.$store.dispatch('START_SESSION_COUNTDOWN');
      }
    },
    getDate({ value }, daysToadd) {
      var date = new Date(value);
      date.setDate(date.getDate() + daysToadd);

      return value ? date : null;
    },
    getMinDate({ value }) {
      return this.getDate({ value }, -1);
    },
    getMaxDate({ value }) {
      return this.getDate({ value }, 0);
    },
    resetForm(type) {
      Object.keys(this.form).forEach((k) => {
        if (k === 'type') return;

        this.$store.commit('SET_QUESTION_VALUE', {
          type,
          value: '',
          question: this.form[k].propertyName
        });
      });

      this.$v.$reset();
    },
    setDirty(propertyName) {
      if (this.$v.form[propertyName]) {
        this.$v.form[propertyName].value.$touch();
      }
    },
    // confirmReplaceValue(question, value) {
    //   if (question.value) {
    //     const value =
    //       typeof question.value === 'object'
    //         ? question.value.label
    //         : question.value;

    //     this.$dialog
    //       .confirm(
    //         {
    //           title: 'Information will be lost',
    //           body:
    //             `<div class="mb-4">By continuing all information specific to selected option <span class="italic">'${value}'</span> will be lost .</div>` +
    //             '<div>Are you sure you want to continue?</div>'
    //         },
    //         { html: true }
    //       )
    //       .then(() => {
    //         this.clearChildrenOf(question);
    //         this.setValue(question, value);
    //       });
    //   } else {
    //     this.setValue(question, value);
    //   }
    // },
    clearChildrenOf(parent) {
      var questions = Object.entries(this.form);

      questions.forEach(([property, question]) => {
        if (property === 'type') return;

        if (this.isChildOf(parent, question)) {
          this.setValue(question, '');
        }
      });

      this.$v.$reset();
    },
    isChildOf({ position }, question) {
      return (
        question.position !== position &&
        question.position.indexOf(position) === 0
      );
    },
    setParentValue(question, value) {
      this.clearChildrenOf(question);
      this.setValue(question, value);
      this.$v.$reset();
    },
    setValue({ propertyName }, value) {
      this.setDirty(propertyName, value);
      this.commit(propertyName, value);
    }
  },
  validations() {
    return {
      form: Object.entries(this.validations).reduce(
        (acc, [k, v]) => ({
          ...acc,
          [k]: { value: v }
        }),
        {}
      )
    };
  }
};

export default formMixin;
